﻿import { dbfetch } from "./dbfetch";
import { Sortable } from "./dragAndDrop";

/**@param {HTMLTableElement} view*/
function initDragAndDrop(view) {
	const viewId = view.dataset.viewid;
	const fid = view.dataset.fid;

	const updateRecord = async (dragElement, dragTarget) => {
		const reload = (anchor) => {
			var url = location.href;
			var hash = url.indexOf("#");
			if (hash >= 0)
				url = url.substring(0, hash);
			if (anchor)
				url += "#" + anchor;
			location.href = url;
			location.reload();
		};
		const id = dragElement.dataset["rowid"];
		const to = dragTarget.dataset["basevalue"];
		var data = new FormData();
		data.append(`f_${fid}`, to);
		try {
			const response = await dbfetch(
				`js.aspx?cmd=rowsave&v=${encodeURIComponent(viewId)}&id=${encodeURIComponent(id)}`, {
				method: "POST",
				body: data
			});
			if (response.ok) {
				const data = await response.json();
				if (data.controldata && data.controldata.invalid) {
					var i = data.controldata.invalid, err = [];
					if (i.common) Array.prototype.push.apply(err, i.common);
					for (var k in i) {
						if (k != "common")
							err.push(i[k]);
					}
					alert("There are errors:\r\n\r\n* " + err.join("\r\n* "));
				}
			} else {
				throw new Error(response.statusText);
			}
		} catch (e) {
			const msg = e.message;
			alert(msg);
			console.error("Item #" + id, " status change error:", msg);
		}
		reload(dragElement.id);
	};

	// each tbody is an own group of droppables
	for (let i = 0, gnum = 1; i < view.tBodies.length; i++) {
		const tbody = view.tBodies[i];
		if (tbody.matches(".v3-kanbanview__group")) {
			const groupBase = `view-${viewId}-group-${gnum++}-`;
			tbody.querySelectorAll(".js-draglist[data-basevalue]").forEach(list => {
				const baseDate = list.dataset.basevalue;
				Sortable.create(list, {
					revertOnSpill: true,
					group: {
						name: groupBase + baseDate,
						pull: true,
						// do not allow dropping to the same group
						put: (to, from) => {
							return from.options.group.name.startsWith(groupBase) && to.options.group.name !== from.options.group.name;
						}
					},
					sort: false,
					draggable: ".js-draggable",
					dataIdAttr: "data-rowid",
					dragClass: "v3-kanbanview-item--dragging",
					ghostClass: "v3-kanbanview-item--dragging-ghost",
					onAdd: event => {
						const { item, from, to } = event;
						if (from != to)
							updateRecord(item, to);
					}
				});
			});
		}
	}
}

function init(context, selector = ".v3-kanbanview[data-viewid]") {
	(context || document).querySelectorAll(selector).forEach(view => {
		initDragAndDrop(view);
	});
}

export { init };